import { TemplateKey } from '../templates'

// might want to separate billing (aka invoice/receipt) to individual invoice and receipt categories
export type FaxCategory = 'auth-instructions' | 'auth-appeals' | 'clinicals' | 'billing'

// queued, media.processed, originated, sending, delivered, failed, initiated, receiving, media.processing, received
export type FaxStatus =
  | 'queued'
  | 'media.processed'
  | 'originated'
  | 'sending'
  | 'delivered'
  | 'failed'
  | 'initiated'
  | 'receiving'
  | 'media.processing'
  | 'received'
  | 're-sending'

export interface BaseFax {
  connection_id: string
  created_at: string
  direction: string
  from: string
  id: string
  storagePath: string
  monochrome: boolean
  type: 'sent' | 'received'
  quality: string
  record_type: string
  status: FaxStatus
  stored_media: boolean
  t38_enabled: boolean
  to: string
  updated_at: string
  notes?: string
  webhook_failover_url?: string
  webhook_url: string
  searchString: string
  assessmentId: string | null
  patientId: string | null
  assessmentName: string | null
  patientFirst: string | null
  patientLast: string | null
  category: TemplateKey | null
}

export interface SentFax extends BaseFax {
  type: 'sent'
  resentAt?: string
  resentFromId?: string
  failure_reason?: string
}

export const isSentFax = (fax: Fax): fax is SentFax => fax.type === 'sent'

export interface ReceivedFax extends BaseFax {
  type: 'received'
  completed_at?: string
}

export type Fax = ReceivedFax | SentFax
